import { useState } from 'react'

import { ChatInput } from '@/components/chat/chat-input'
import { getAppUrl } from '@/config/marketing-nav.config'

/**
 * Homepage hero composer: the interactive ChatInput wired for the marketing
 * page. Typing is local state; submitting carries the trader's prompt into the
 * app signup flow (same destination as the hero CTAs). Width matches the prior
 * hero composer via `--ivy-chat-max-width`.
 */
function heroSignupUrl(prompt: string): string {
  const trimmed = prompt.trim()
  return trimmed
    ? getAppUrl(`/signup?prompt=${encodeURIComponent(trimmed)}`)
    : getAppUrl('/signup')
}

export function HeroChatInput() {
  const [value, setValue] = useState('')

  return (
    <div className="marketing-hero-composer mx-auto mt-10 w-full max-w-[var(--ivy-chat-max-width)]">
      <ChatInput
        value={value}
        onChange={setValue}
        onSubmit={(prompt) => window.location.assign(heroSignupUrl(prompt))}
        allowEmptySubmit
        submitButtonClassName="transition-[filter] hover:brightness-110"
        title=""
        inputAriaLabel="Ask Ivy anything"
        topGlow
      />
    </div>
  )
}
